import { useEffect, useState } from 'react';
import { CHECKOUT_BASE } from '../data/content';

export function useCheckoutUrl() {
  const [checkoutUrl, setCheckoutUrl] = useState(CHECKOUT_BASE);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search).toString();
    if (!params) return;
    const joiner = CHECKOUT_BASE.includes('?') ? '&' : '?';
    setCheckoutUrl(`${CHECKOUT_BASE}${joiner}${params}`);
  }, []);

  return checkoutUrl;
}
